export const subscriptionDateChoices = [
  { _id: 1, name: "Януари" },
  { _id: 2, name: "Февруари" },
  { _id: 3, name: "Март" },
  { _id: 4, name: "Април" },
  { _id: 5, name: "Май" },
  { _id: 6, name: "Юни" },
  { _id: 7, name: "Юли" },
  { _id: 8, name: "Август" },
  { _id: 9, name: "Септември" },
  { _id: 10, name: "Октомври" },
  { _id: 11, name: "Ноември" },
  { _id: 12, name: "Декември" },
];

export const subscriptionYearChoices = [
  { id: "2023", name: "2023" },
  { id: "2024", name: "2024" },
  { id: "2025", name: "2025" },
  { id: "2026", name: "2026" },
  { id: "2027", name: "2027" },
  { id: "2028", name: "2028" },
  { id: "2029", name: "2029" },
  { id: "2030", name: "2030" },
  { id: "2031", name: "2031" },
  { id: "2032", name: "2032" },
  { id: "2033", name: "2033" },
];

export const paymentStatus = [
  { id: "Pending", name: "Очаква плащане" },
  { id: "Paid", name: "Платен" },
  { id: "Refused", name: "Отказан" },
];
export const agreeStatus = [
  { id: false, name: "Не" },
  { id: true, name: "Да" },
];
export const paymentType = [
  { id: "Bank", name: "Банка" },
  { id: "Card", name: "Карта" },
];
export const dateOptions = {
  year: "numeric",
  month: "long",
  day: "numeric",
  // hour: "numeric",
  // minute: "numeric",
};

export const vaucherChoices = [
  { _id: "RegulationSeven", name: "Наредба №7" },
  { _id: "RegulationEleven", name: "Наредба №11" },
  { _id: "Gift", name: "Подарък" },
  { _id: "SocialBenefits", name: "Социални придобивки " },
];
export const newsChoices = [
  { id: "News", name: "Новини" },
  { id: "Vouchers", name: "Ваучери" },
  { id: "Messages", name: "Съобщения" },
];
export const languageChoices = [
  { id: "Bg", name: "bg" },
  { id: "En", name: "en" },
];

export const auctionType = [
  { id: "Auction", name: "Наем" },
  { id: "Sale", name: "Продажби" },
];
export const ordersStatusChoices = [
  { id: "Active", name: "Активна" },
  { id: "Closed", name: "Затворена" },
  { id: "Assigned", name: "Възложена" },
  { id: "Fulfilled", name: "Изпълнена" },
  { id: "Planned", name: "Планирана" },
  { id: "Terminated", name: "Прекратена" },
];
export const orderType = [
  { id: "Main", name: "Главна" },
  { id: "ArtTwentyParagraphFour", name: "Поръчка по чл.20 п.4" },
];
export const buyerProfileType = [
  { id: "MarketConsulting", name: "Пазарни консултации" },
  { id: "ArtTwentyParagraphFour", name: "Покани по чл.20, ал. 4 от ЗОП" },
  // { id: "ArtTwentyOneParagraphSix", name: "Покани по чл.21, ал. 6 от ЗОП" },
];
export const projectType = [
  { id: "National", name: "Национален" },
  { id: "International", name: "Международен" },
];
export const initialValues = {
  language: "Bg",
};
export const positionType = [
  { id: 1, name: "Централно управление" },
  { id: 2, name: "Други обяви" },
  { id: 3, name: "Специализирано поделение „ИМС/Булпост" },
  { id: 4, name: "Български разменно-сортировъчен център" },
  { id: 5, name: "РУ „Западен регион" },
  { id: 6, name: "РУ „Южен централен регион" },
  { id: 7, name: "РУ „Северен централен регион" },
  { id: 8, name: "РУ „Югоизточен регион" },
  { id: 9, name: "РУ „Североизточен регион" },
];
export const changedPropsLabel = {
  subscription_complaints: "Реклмация",
  PaymentType: "Метод на плащане",
  PaymentStatus: "Статус на плащане",
  PurchaseDate: "Дата на плащане",
  GiverFirstName: "Име на заявител",
  GiverLastName: "Фамилия на заявител",
  GiverPhoneNumber: "Телефон на заявителя",
  GiverEmail: "E-мейл на заявителя",
  ReceiverFirstName: "Име на получател",
  ReceiverLastName: "Фамилия на получател",
  ReceiverEmail: "E-мейл за доставка на ел изд.",
  ReceiverPhoneNumber: "Телефон на получател",
  ReceiverPostcode: "ПК на получател",
  ReceiverDistrict: "Област на получател ",
  ReceiverMunicipality: "Издадена фактурана на получател ",
  ReceiverCity: "Нас. място на получател / Град",
  ReceiverNeighborhood: "Квартал на получател ",
  ReceiverStreet: " Улица на получател ",
  ReceiverStreetNumber: "Улица номер на получател ",
  ReceiverBuilding: "Бл. на получател ",
  ReceiverEntrance: "Вх. на получател ",
  ReceiverFloor: "Ет. на получател ",
  ReceiverApartment: "Ап. на получател ",
  IsInvoiceOrdered: "Желае фактура",
  IsInvoiceGiven: "Издадена фактура",
  InvoiceNumber: "Фактура номер",
  InvoiceCompanyName: "Титуляр на фактурата",
  InvoiceCompanyEmail: "Фирма - E-мейл",
  InvoiceIdentificationNumber: "Идентификационен номер/ЕГН",
  InvoiceTaxId: "ИН по ЗДДС",
  InvoiceAccountablePerson: "МОЛ",
  InvoiceCompanyDistrict: "Фирма - Област",
  InvoiceCompanyMunicipality: "Фирма - Община",
  InvoiceCompanyCity: "Фирма - Град",
  InvoiceCompanyNeighborhood: "Фирма - Квартал",
  InvoiceCompanyStreet: "Фирма - Улица",
  InvoiceCompanyStreetNumber: "Фирма - Номер на улица",
  InvoiceCompanyPostalCode: "Фирма - ПК",
  InvoiceCompanyBuilding: "Фирма - Блок",
  InvoiceCompanyEntrance: "Фирма - Вход",
  InvoiceCompanyFloor: "Фирма - Етаж",
  InvoiceCompanyApartment: "Фирма - Ап.",
  InvoiceAddBillingAddress: "Допълнителен адрес за получаване",
  InvoiceBillingCompanyName: "Допълнителен адрес за получаване - Фактура",
  InvoiceBillingEmail: "Допълнителен E-мейл",
  InvoiceBillingAccountablePerson: "Лице за контакт",
  InvoiceBillingDistrict: "Допълнителен адрес за получаване - Област",
  InvoiceBillingMunicipality: "Допълнителен адрес за получаване - Община",
  InvoiceBillingCity: "Допълнителен адрес за получаване - Град",
  InvoiceBillingNeighborhood: "Допълнителен адрес за получаване - Квартал",
  InvoiceBillingStreet: "Допълнителен адрес за получаване - Улица",
  InvoiceBillingStreetNumber: "Допълнителен адрес за получаване - Номер на улица",
  InvoiceBillingPostalCode: "Допълнителен ПК",
  InvoiceBillingBuilding: "Допълнителен адрес за получаване - Бл.",
  InvoiceBillingEntrance: "Допълнителен адрес за получаване - Вх.",
  InvoiceBillingFloor: "Допълнителен адрес за получаване - Ет.",
  InvoiceBillingApartment: "Допълнителен адрес за получаване - Ап.",
};
